import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LockOpenIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16.1999V13.7999M6.37505 7.88562C6.37505 4.84671 8.78362 2.3999 11.775 2.3999C13.6385 2.3999 15.2757 3.34934 16.2455 4.7999M6.60005 8.7999C5.61005 8.7999 4.80005 9.62276 4.80005 10.6285V19.7713C4.80005 20.777 5.61005 21.5999 6.60005 21.5999H17.4001C18.3901 21.5999 19.2001 20.777 19.2001 19.7713V10.6285C19.2001 9.62276 18.3901 8.7999 17.4001 8.7999H6.60005Z"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

LockOpenIcon.displayName = 'LockOpenIcon';
